<template>
<!-- destroy-on-close="true" bug,关闭还会调一次mounted，下次进来缺不调 -->
  <el-dialog
  title="请填写审核意见"
  width="70%"
  :visible.sync="batchReview.show"
  :append-to-body="true"
  :fullscreen="batchReview.batchAuditReferMap.globalParam.fullscreen">
    <!-- :fullscreen=true -->
    &nbsp;&nbsp;&nbsp;&nbsp;你一共选择了{{selectionList.length}}条数据进行批量操作，详情
    <a href="#" @click="batchReview.showSelectList = !batchReview.showSelectList">
      <font color='blue'>
        {{batchReview.showSelectList === false ? '展开' : '收起'}}
      </font>
    </a>
    <avue-crud :data="selectionList" :option="option" v-if="batchReview.showSelectList">
      <template slot="summary" slot-scope="{row}">
        <div v-html="row.summary" style="text-align: left;"></div>
      </template>
    </avue-crud>
    <avue-form ref="confirmForm" :option="batchReview.options" v-model="batchReview.modeldata">
    </avue-form>
    <el-divider content-position="left" v-if="batchReview.batchAuditReferMap.globalParam.showDivider"><h2>{{batchReview.batchAuditReferMap.divider.title}}</h2></el-divider>
    <div v-html="batchReview.batchAuditReferMap.caption.value" v-if="batchReview.batchAuditReferMap.globalParam.showCaption" :style='batchReview.batchAuditReferMap.caption.style'></div>
    <br v-if="batchReview.batchAuditReferMap.globalParam.showTable" />
    <div class="localTable" v-if="batchReview.batchAuditReferMap.globalParam.showTable">
      <easyCruds
      :tableInfo="batchReview.batchAuditReferMap.extTable"
      @openUrl1="openUrl1"
      @openUrl2="openUrl2"
      @openUrl3="openUrl3"
      @openUrl4="openUrl4"
      @openUrl5="openUrl5"
      />
    </div>
    <iframe :src="batchReview.batchAuditReferMap.iframe.src" class="iframe" ref="iframe" v-if="batchReview.batchAuditReferMap.globalParam.showIframe" :height="batchReview.batchAuditReferMap.iframe.height"></iframe>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose()" >取消</el-button>
      <template v-if="extBtns.length">
      <el-button v-for="(item, i) in extBtns"
      :key="i" @click="handleSubmit({
        ...batchReview.modeldata,
        extButtonParam: {
          prop: item.prop,
          other: item.other,
          name: item.name,
          label: item.label
        }
      })">
        {{ item.name }}
      </el-button>
      </template>
      <template v-else>
      <el-button type="primary" @click="handleSubmit(batchReview.modeldata)">确认</el-button>
      </template>
    </span>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import easyCruds from '@/framework/components/baseComponent/easyCrud/easyCruds.vue'
import { setDisplay, initDynamicDisplay, setDynamicDisplay } from '@/workFlow/formComponent/viewForm/ViewForm.vue'
import { extButtonList } from './mixExtBtns'
export default {
  data() {
    return {
      extBtns: []
    }
  },
  props: ['batchReview', 'selectionList', 'extButtonList', 'taskFormPropertyList'],
  mounted() {

  },
  components: { easyCruds },
  watch: {
    extButtonList,
    getCaseCade: {
      handler(val, oldVal) {
        if (val && !oldVal) {
          initDynamicDisplay(val, this.batchReview.options.column, this.batchReview.modeldata)
        }

        if (!oldVal) {
          return false
        }

        // todo check start
        if (_.isEqual(val, oldVal)) {
          const {
            items
          } = val
          items.forEach(item => {
            const {
              dynamicDisplayData,
              prop
            } = item
            const curVal = this.batchReview.modeldata[prop]
            dynamicDisplayData.forEach(item2 => {
              if (curVal === item2.value) {
                setDisplay(item2, this.batchReview.options.column)
              }
            })
          })
        }
        // todo check end

        setDynamicDisplay(val, oldVal, this.batchReview.modeldata, this.batchReview.options.column)
      },
      immediate: true
    }
  },
  computed: {
    getCaseCade: function() {
      if (!this.batchReview.options.column) {
        return false
      }
      const items = this.batchReview.options.column.filter(item => (
        (item.type === 'select' || item.type === 'radio') &&
        item.dynamicDisplayData
      ))

      // console.log(items, '+++', this.batchReview)

      if (items) {
        // console.log(this.batchReview.modeldata, 11)
        const cases = {
          items,
          keys: {}
        }
        for (let i = 0; i < items.length; i++) {
          cases.keys[i] = this.batchReview.modeldata[items[i].prop]
        }
        return cases
      } else {
        return []
      }
    },
    option() {
      return {
        addBtn: false,
        delBtn: false,
        editBtn: false,
        columnBtn: false,
        menu: false,
        index: true,
        border: true,
        tip: false,
        refreshBtn: false,
        header: false,
        page: false,
        align: 'center',
        column: [
          {
            prop: 'businessTitle',
            label: '标题',
            type: 'input'
          }, {
            prop: 'summary',
            label: '摘要',
            slot: true,
            minWidth: 120
          },
          {
            prop: 'processInstanceStartUserName',
            label: '申请人',
            type: 'input'
          }
        ]
      }
    }
  },
  methods: {
    openUrl1(index, row) {
      window.open(row.url1, '_blank')
    },
    openUrl2(index, row) {
      window.open(row.url2, '_blank')
    },
    openUrl3(index, row) {
      window.open(row.url3, '_blank')
    },
    openUrl4(index, row) {
      window.open(row.url4, '_blank')
    },
    openUrl5(index, row) {
      window.open(row.url5, '_blank')
    },
    handleSubmit(formData) {
      formData = this.specialValueCommitConversion(formData)
      // 数据验证
      this.$refs.confirmForm.validate((valid) => {
        if (valid) {
          this.$emit('handleSubmit', formData)
        }
      })
    },
    handleClose() {
      this.batchReview.show = false
    },
    /**
     * 特殊值提交转换
     */
    specialValueCommitConversion(formData) {
      /** 用户选择器格式转换 */
      this.batchReview.options.column.filter(e => e.type === 'flowUserChoose').forEach(item => {
        let oldVal = formData[item.prop]
        if (oldVal && Array.isArray(oldVal) && oldVal.length && item.callIdName) {
          formData['$' + item.callIdName] = oldVal.map(item => item.name).toString()
          let id = oldVal.map(item => item.id)
          formData[item.callIdName] = item.maxRows === 1 ? id.toString() : id
        } else if (item.callIdName) {
          formData['$' + item.callIdName] = ''
          formData[`${item.callIdName}`] = item.maxRows === 1 ? '' : []
        }
      })
      return formData
    }
  }

}
</script>
<style lang="scss" scoped>
.drawer-top {
  position: relative;
  margin-top: -20px;
  margin-left: 40px;
  margin-right: 40px;
  padding-bottom: 15px;
  text-align: center;
  font-size: 25px;
  font-weight: bold; //border: 1px solid red;
}
.iframe {
    width: 100%;
    border: 0;
    overflow: hidden;
    box-sizing: border-box;
  }
</style>
